import { AlertType } from './alerts';

// Devuelve el código SVG del ícono correspondiente al tipo de alerta indicado
export const getAlertIconSVGCode = (alertType: AlertType): string => {
  let svgCode: string = '';

  switch (alertType) {
    case 'info':
      svgCode = `
        <svg class="icon info" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
          <circle class="info__circle" cx="26" cy="26" r="25" fill="none" />
          <path class="info__check" fill="none" stroke="#fff" d="M26 21 v20 M26 13 v2" />
        </svg>
      `;
      break;

    case 'success':
      svgCode = `
        <svg class="icon checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
          <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
          <path class="checkmark__check" fill="none" stroke="#fff" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
        </svg>
      `;
      break;

    case 'warning':
      svgCode = `
        <svg class="icon warning" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
          <circle class="warning__circle" cx="26" cy="26" r="25" fill="none" />
          <path class="warning__check" fill="none" stroke="#fff" d="M26 13 v20 M26 38 v2" />
        </svg>
      `;
      break;

    case 'error':
      svgCode = `
        <svg class="icon cross" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
          <circle class="cross__circle" cx="26" cy="26" r="25" fill="none" />
          <path class="cross__check" fill="none" stroke="#fff" d="M16 16 L36 36 M36 16 L16 36" />
        </svg>
      `;
  }

  return svgCode;
};
